import CatalogueIcon from '@/shared/assets/icons/sidebar/layers.svg';
import HomeIcon from '@/shared/assets/icons/sidebar/home.svg';
import EducationIcon from '@/shared/assets/icons/sidebar/book.svg';
import CalendarIcon from '@/shared/assets/icons/sidebar/calendar.svg';
import ChatIcon from '@/shared/assets/icons/sidebar/chat.svg';
import { SvgType } from '@/shared/types/common';
import { routerPath } from './router';

export interface IMenuItem {
  id: number;
  label: string;
  href?: string;
  icon?: SvgType;
  children?: IMenuItem[];
}

export const STUDENT_MENUS: IMenuItem[] = [
  {
    id: 1,
    label: 'Home',
    href: routerPath.main,
    icon: HomeIcon,
  },
  {
    id: 2,
    label: 'My Learning',
    icon: EducationIcon,
    children: [
      {
        id: 21,
        label: 'My Courses',
        href: routerPath.enrollments,
      },
      {
        id: 22,
        label: 'Assignments',
        href: routerPath.assignments,
      },
    ],
  },
  {
    id: 3,
    label: 'Catalogue',
    href: routerPath.catalogue,
    icon: CatalogueIcon,
  },
  {
    id: 4,
    label: 'Calendar',
    href: routerPath.calendar,
    icon: CalendarIcon,
  },
  {
    id: 5,
    label: "Chats",
    href: routerPath.chats,
    icon: ChatIcon,
  },
];

export const TEACHER_MENUS: IMenuItem[] = [
  {
    id: 1,
    label: 'Home',
    href: routerPath.main,
    icon: HomeIcon,
  },
  {
    id: 2,
    label: 'Courses',
    href: routerPath.teacherCourses,
    icon: CatalogueIcon,
  },
  {
    id: 3,
    label: 'Assignments',
    href: routerPath.teacherAssignments,
    icon: EducationIcon,
  },
  {
    id: 4,
    label: 'Calendar',
    href: routerPath.calendar,
    icon: CalendarIcon,
  },
  {
    id: 5,
    label: "Chats",
    href: routerPath.chats,
    icon: ChatIcon,
  },
];
